exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview.select-item[data-v-1bb2cd3f]{border:2px solid #fff;border-radius:.35rem;cursor:pointer}.asset-preview.select-item .thumbnail[data-v-1bb2cd3f]{padding:0;height:128px}.asset-preview.select-item .thumbnail img[data-v-1bb2cd3f]{max-width:100%;max-height:128px}.asset-preview.select-item:hover .card-body .asset-info.stay[data-v-1bb2cd3f]{opacity:1}.asset-preview.select-item.selected:hover .asset-select-overlay.deselect .check-icon[data-v-1bb2cd3f]{display:none}.asset-preview.select-item.selected:hover .asset-select-overlay.deselect .minus-icon[data-v-1bb2cd3f]{display:inline}", ""]);

// exports
